/**
 * 全局公用的一些基本元素
 */

import styled from "styled-components";
import { getThemeColor, MAIN_PRIMARY, H00 } from "constants/colors";
import { Switch, Menu } from "@bit-design/react";
import { getStyle } from "constants/colors";
export const SmallSwitch = styled(Switch)`
  height: 18px;
  line-height: 16px;
  min-width: 32px;

  &::after {
    width: 14px;
    height: 14px;
    border: 14px;
  }
`;

export const FlexStyle = (content = "space-between", items = "center") => {
  return `
    display: flex;
    align-items: ${items};
    justify-content: ${content};
`;
};
export const MediaScreenMobile = (content, deviece = "768px") => {
  return `
    @media screen and (max-width: ${deviece}) {
        ${content}
    }
    `;
};

// 768以下 为小屏幕尺寸的样式，不包含768 所以改成 767
export const MediaScreenMobileStrategy = (content, deviece = "767px") => {
  return `
    @media screen and (max-width: ${deviece}) {
        ${content}
    }
    `;
};

/**
 * 默认两端对齐的Div容器
 */
export const FlexDiv = styled.div`
  ${FlexStyle()}
`;

/**
 * 左对齐的Div容器
 */
export const FlexStartDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

/**content_bg
 * 头部的下拉菜单包裹
 */
export const HeaderDropdownMenuWrapper = styled.div`
  // width: 280px;
  // background: var(--background-primary);
  // //box-shadow: var(--background-box-shadow);
  // border: 1px solid var(--background-disabled);
  // border-radius: 12px;
  // position: relative;
  // overflow: hidden;
  width: 200px;
  padding: 10px 12px;
  margin-top: 19px;
  background: ${getThemeColor("dropdown_menu_new")};
  box-shadow: 0 0 5px 0 ${getThemeColor("language_boxshadow")};
  border-radius: 4px;
  position: relative;
`;

/**
 * 头部的下拉菜单覆盖
 */
export const HeaderDropdownMenuBody = styled(Menu)<{ each?: string }>`
  background: var(--dropdown_menu_new) !important;
  padding: 16px !important;
  border: none !important;
  box-shadow: none !important;
  .bit-dropdown-menu-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: auto;
    line-height: 22px;
    padding: 9px 16px;
    border-radius: 8px;
    color: var(--content-primary);
    margin: 0;
    .iconfont {
      margin-inline-end: 12px;
    }
  }

  .bit-menu-item-active {
    background-color: var(--background-secondary) !important;
  }
  .bit-menu-item-selected {
    color: var(--content-link-default);
    background-color: var(--background-secondary) !important;
  }
  .iconfont {
    font-size: 28px;
    vertical-align: middle;
  }
`;
/**
 * 头部的下拉菜单覆盖
 */
export const HeaderDropdownMenuBodyNew = styled(Menu)<{ each?: string }>`
  background: var(--dropdown_menu_new) !important;
  // padding: 16px !important;
  border: none !important;
  box-shadow: none !important;
  .bit-dropdown-menu-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: auto;
    line-height: 22px;
    padding-inline-start: 16px;
    padding-inline-end: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 8px;
    color: var(--content-primary);
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }

    .iconfont {
      margin-inline-end: 12px;
    }
    .bit-dropdown-menu-title-content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .bit-dropdown-menu-item:hover,
  .bit-dropdown-menu-item-active {
    background-color: ${getThemeColor("dropdown_list_hover_new")} !important;
    color: var(--color-primary);
  }
  .bit-dropdown-menu-item-selected {
    background-color: var(--background-secondary);
    &:last-child {
      background-color: none;
      color: none;
    }
  }
  .iconfont {
    font-size: 30px;

    vertical-align: middle;
  }
`;

/**
 * 分割线
 */
export const HeaderDropdownMenuSplit = styled.div<{ top?: string }>`
  height: 1px;
  margin-top: ${(props) => (props.top ? props.top : "0")}px;
  background-color: ${getStyle("#383F4C", "#f2f3f5")};
`;

/**
 * 用作按钮的A标签
 */
export const ButtonLikedA = styled.a`
  ${FlexStyle()}
  &:hover {
    color: var(--color-primary-hover-bg);
  }
`;

export const IconButton = styled.i`
  font-size: 12px;
  cursor: pointer;
  color: var(--color-primary);
  margin-inline-start: 4px;
`;

export const DialogBigTitle = styled(FlexStartDiv)`
  //margin-bottom: 8px;
  display: inline-block;
  // line-height: 38px;
  // height: 28px;
  font-size: 24px;
  text-align: start;
  font-weight: 500;
  word-break: break-word;
  margin-inline-end: 40px;
  color: ${getStyle(H00)};
  cursor: pointer;
  .iconfont {
    margin-inline-end: 12px;
  }
  &.active {
    color: ${MAIN_PRIMARY};
  }
  ${MediaScreenMobileStrategy(`
        display: none;
    `)}
`;

export const NewDialogBigTitle = styled(FlexStartDiv)`
  margin-bottom: 27px;
  display: inline-block;
  line-height: 30px;
  height: 30px;
  font-size: 26px;
  text-align: left;
  font-weight: 500;
  word-break: break-word;
  margin-inline-end: 25px;
  color: ${getStyle(H00)};
  cursor: pointer;
  .iconfont {
    margin-inline-end: 12px;
  }
  &.active {
    color: ${MAIN_PRIMARY};
  }
  ${MediaScreenMobileStrategy(`
        display: none;
    `)}
`;
export const NewDialogTitle = styled(FlexStartDiv)`
  display: inline-block;
  font-size: 20px;
  text-align: start;
  font-weight: 500;
  word-break: break-word;
  margin-inline-end: 40px;
  margin-bottom: 8px;
  color: ${getStyle(H00)};
  cursor: pointer;
  .iconfont {
    margin-inline-end: 12px;
  }
  &.active {
    color: ${MAIN_PRIMARY};
  }
  ${MediaScreenMobileStrategy(`
        display: none;
    `)}
`;
export const NewDialogButtonFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  width: 100%;
  .bit-btn {
    flex: 1;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    transition: 0.1s;
    font-size: 14px;
    border-radius: 48px;
    height: 40px;
    line-height: 40px;
    padding: 0 46px !important;
    &:first-child {
      margin-right: 12px;
    }
  }
  @media screen and (max-width: 768px) {
    .bit-btn {
      padding: 0 10px !important;
    }
  }
`;

export const DialogButtonFooter = styled.div`
  ${FlexStyle("space-between", "center")};
  gap: 10px;
  margin-top: 32px;
  &.phoneBox {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const TipFooter = styled(DialogButtonFooter)`
  ${FlexStyle()}
  ${MediaScreenMobileStrategy(`
        display: block;
        button {
            margin-top: 14px;
            width: 100%;
            border-radius: 4px;
        }
    `)}
`;

// 编辑图标

export const EditIcon = styled.span`
  cursor: pointer;

  .iconfont {
    font-size: 12px;
    color: ${MAIN_PRIMARY};
    margin-inline-start: 4px;
  }
`;

export const TinySwitch = styled(Switch)`
  height: 20px;
  line-height: 20px;
  min-width: 22px;
  width: 28px;

  &::after {
    width: 12px;
    height: 12px;
    border: 12px;
  }
`;
